import {DateRangeFilterDto} from "@/model/api/CriteriaApi"
import {Filter} from "@/model/filter/Filter"

export class DateRangeFilter implements Filter {
  name: string

  constructor(dto: DateRangeFilterDto) {
    this.name = dto.id
  }
}


export interface DateRange {
  from: string
  to: string
}
